"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAjax = useAjax;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function useAjax(ajaxFunction) {
  var initialValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var initialLoading = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var _React$useState = _react["default"].useState(initialValue),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      response = _React$useState2[0],
      setResponse = _React$useState2[1];

  var _React$useState3 = _react["default"].useState({
    loading: initialLoading,
    success: false,
    failure: false,
    message: ''
  }),
      _React$useState4 = (0, _slicedToArray2["default"])(_React$useState3, 2),
      meta = _React$useState4[0],
      setMeta = _React$useState4[1];

  function fetchFunction() {
    return _fetchFunction.apply(this, arguments);
  }

  function _fetchFunction() {
    _fetchFunction = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var res,
          result,
          _args = arguments;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setMeta(function (prev) {
                return _objectSpread(_objectSpread({}, prev), {}, {
                  loading: true
                });
              });
              _context.next = 3;
              return ajaxFunction.apply(void 0, _args);

            case 3:
              res = _context.sent;
              _context.next = 6;
              return res.json();

            case 6:
              result = _context.sent;

              if (res.ok) {
                setResponse(result);
              }

              setMeta(function (prev) {
                var nextState = _objectSpread(_objectSpread({}, prev), {}, {
                  loading: false
                });

                if (res.ok) {
                  nextState.success = true;
                } else {
                  nextState.failure = true;
                }

                if (result !== null && result !== void 0 && result.message) {
                  nextState.message = result.message;
                }

                return nextState;
              });

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _fetchFunction.apply(this, arguments);
  }

  function reset() {
    setMeta({
      loading: false,
      success: false,
      failure: false,
      message: ''
    });
  }

  var metaObject = _objectSpread(_objectSpread({}, meta), {}, {
    reset: reset
  });

  return [response, fetchFunction, metaObject];
}